import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_3: FaireProductEntity = {
  token: "toysmith-3",
  type: "product",
  name: "That's Crackin' Mystery Egg, Assorted",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/268b06790f7e06bc047c669375eb860b8f82a83d03dcd5186a4c2ea7c133b931.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 6.5,
  msrpDollars: 13,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
